import { SET_TABLE_CURRENT_PAGE } from '../../actions/ui/tablePages';

export type TablePagesState = { [tableId: string]: number };

const initialState: TablePagesState = {};

type ActionType = {
  type: string;
  payload: {
    id: string;
    currentPage: number;
  };
};

/**
 * C-11.7: slice independiente para la UI del paginador (`currentPage`).
 *
 * Vive separado de `cursorTables` (filtros + cursor de query) porque los
 * 30+ callsites que dispatchean `SET_CURSOR` hacen REPLACE del objeto entero;
 * si `currentPage` viviera en la misma entrada, cualquier cambio de filtro
 * lo borraría. Aquí es ortogonal: ningún dispatch a `cursorTables` afecta
 * `tablePages` y viceversa.
 *
 * Sin estado inicial poblado: el hook `useTableCurrentPage` devuelve `1`
 * cuando la entrada no existe (default lazy).
 */
export default function tablePages(
  state: TablePagesState = initialState,
  { type, payload }: ActionType,
): TablePagesState {
  switch (type) {
    case SET_TABLE_CURRENT_PAGE:
      return {
        ...state,
        [payload.id]: payload.currentPage,
      };
    default:
      return state;
  }
}
